export default "__VITE_ASSET__Snv2E_vh__"